/* Branches */
export const BRANCH_ENVIRONMENT_PRODUCTION_ENUM = 'PRODUCTION';
export const BRANCH_ENVIRONMENT_DEVELOPMENT_ENUM = 'DEVELOPMENT';
export const BRANCH_ENVIRONMENT_SCRATCH_ENUM = 'SCRATCH';
export const BRANCH_ENVIRONMENT_PRODUCTION = 'production';
export const BRANCH_ENVIRONMENT_DEVELOPMENT = 'development';
export const BRANCH_ENVIRONMENT_SCRATCH = 'scratch';
export const BRANCH_ENVIRONMENTS = [
    BRANCH_ENVIRONMENT_PRODUCTION,
    BRANCH_ENVIRONMENT_SCRATCH,
    BRANCH_ENVIRONMENT_DEVELOPMENT
];
